<script>
  export let item;
  import CloseIcon from "#lib/components/svg/CloseIcon.svelte";
  import { cartStore } from "#lib/stores/cart.js";
  import AddIcon from "#lib/components/svg/AddIcon.svelte";
  import SubtractIcon from "#lib/components/svg/SubtractIcon.svelte";
  import { formatPrice } from "#lib/utils/format.js";
  import { updateCartItem } from "#lib/utils/cart.js";
  import { userCountryStore } from "#lib/stores/countryStore.js";
  import { US_COUNTRIES, AU_COUNTRIES } from "#lib/constants.js";

  // Handle both direct items and items with node structure
  $: itemData = item.node || item;
  $: {
    const productTitle = itemData.merchandise?.product?.title || itemData.title;
    const variantTitle = itemData.merchandise?.title || 
                        itemData.merchandise?.selectedOptions?.[0]?.value || 
                        itemData.variantTitle;
    const displayTitle = productTitle;
  }


  $: shopifyTotalAmount = $cartStore.totalAmount;
  $: shopifyTotalCurrency = $cartStore.totalCurrency;

  // const CurrenyCountryMap = {
  //    //Us-plug
  //    'US': '$',
  //   'AU': 'AU$',
  //   'NZ': 'NZ$',

  //   //GB-plug
  //   'CY': '£',
  //   'MT': '£',
  //   'IE': '£',
  //   'GB': '£',

  //   //Eu-plug

  //   'AT': 'Austria',
  //   'BE': 'Belgium',
  //   'BG': 'Bulgaria',
  //   'BY': 'Belarus',
  //   'HR': 'Croatia',
  //   'CZ': 'Czech Republic',
  //   'DK': 'Denmark',
  //   'EE': 'Estonia',
  //   'FI': 'Finland',
  //   'EL': 'Greece',
  //   'HU': 'Hungary',
  //   'IE': 'Ireland',
  //   'IT': 'Italy',
  //   'LV': 'Latvia',
  //   'LT': 'Lithuania',
  //   'LU': 'Luxembourg',
  //   'NL': 'Netherlands',
  //   'PL': 'Poland',
  //   'PT': 'Portugal',
  //   'RO': 'Romania',
  //   'SK': 'Slovakia',
  //   'ES': 'Spain',
  //   'SE': 'SEK',
  //   'DE': 'Germany',
  // }



  $: price = parseFloat(itemData.cost?.totalAmount?.amount || itemData.price);
  $: quantity = itemData.quantity;
  $: productTitle = itemData.title || itemData.merchandise?.product?.title;
  $: variantTitle = itemData.merchandise?.title || 
                    itemData.merchandise?.selectedOptions?.[0]?.value || 
                    '';
  $: displayTitle = productTitle;
  $: image = itemData.merchandise?.product?.images?.edges[0]?.node?.originalSrc || itemData.image;
  // Determine currency based on user's selected country (same logic as product page and cart)
  $: currencyCode = (() => {
    if (!$userCountryStore) return 'EUR'; // Default fallback
    if (US_COUNTRIES.includes($userCountryStore) || AU_COUNTRIES.includes($userCountryStore)) {
      return 'USD';
    }
    return 'EUR';
  })();
  $: merchandiseId = itemData.merchandise?.id || itemData.variantId;
  $: lineId = itemData.id;

  // Get the individual item price by dividing the total by quantity
  $: unitPrice = price / quantity;
  $: totalPrice = price;  // This is already the total for the line item

  // Debug logging for LineItem
  // $: {
  //   console.log('🛍️ LineItem Debug:', {
   
  //     shopifySubtotalAmount,
  //     price,
  //     currencyCode,

  //     lineId,
  //     productTitle,
  //     variantTitle,
  //     userCountry: $userCountryStore,
  //     currencyCode,
  //     shopifyData: {
  //       originalPrice: itemData.cost?.totalAmount?.amount,
  //       originalCurrency: itemData.cost?.totalAmount?.currencyCode,
  //       unitPrice: itemData.merchandise?.price?.amount,
  //       unitCurrency: itemData.merchandise?.price?.currencyCode
  //     },
  //     displayData: {
  //       price,
  //       quantity,
  //       formattedPrice: formatPrice(price, currencyCode)
  //     }
  //   });
  // }

  async function incrementQuantity() {
    try {
      const response = await updateCartItem($cartStore.id, lineId, quantity + 1);
      
      if (!response?.cart?.lines?.edges) {
        throw new Error('Invalid response structure from cart operation');
      }
      
      // Update the store with the new cart state
      cartStore.fetch(); // Fetch the latest cart state
    } catch (error) {
      console.error('Error incrementing quantity:', error);
    }
  }

  async function decrementQuantity() {
    try {
      if (quantity <= 1) {
        // If quantity is 1, remove the item completely
        await removeCartItem();
      } else {
        // Otherwise, just decrease by 1
        const response = await updateCartItem($cartStore.id, lineId, quantity - 1);
        
        if (!response?.cart?.lines?.edges) {
          throw new Error('Invalid response structure from cart operation');
        }
        
        // Update the store with the new cart state
        cartStore.fetch(); // Fetch the latest cart state
      }
    } catch (error) {
      console.error('Error decrementing quantity:', error);
    }
  }

  async function removeCartItem() {
    try {
      const response = await fetch('/api/cart/remove', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cartId: $cartStore.id,
          lineId
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to remove item');
      }

      await cartStore.fetch(); // Fetch the latest cart state
    } catch (error) {
      console.error('Error removing item:', error);
    }
  }
</script>


<div class="line-item-parent-container flex-center">
  <button
    class="delete cl-btn"
    on:click={removeCartItem}><CloseIcon /></button
  >
    <div class="img-container">
      <img
        src="/images/product-photos/product_photo_1_1.webp"
        alt=""
      />
    </div>
 
  
 

  <div>
    <p class="title">{displayTitle}</p>
    {#if variantTitle !== 'Default Title'}
      <p class="variant">{variantTitle}</p>
    {/if}
    <div class="price-q-counter-container">
      <div class="counter ">
        <button
          class="cl-btn"
          on:click={decrementQuantity}
        ><SubtractIcon /></button
        ><span>{quantity}</span><button
          class="cl-btn"
          on:click={incrementQuantity}
        ><AddIcon /></button
        >
      </div>
    </div>
  </div>
  <div class="price-info">
    
    <p class="total-price">
      <!-- Always the line's own total in its own currency - the old
           country-guess fallback rendered the whole-cart subtotal here. -->
      {formatPrice(price, itemData.cost?.totalAmount?.currencyCode || currencyCode)}
    </p>
  </div>
</div>

<style lang="scss">

  span {
    color: black;
  }
  $color_3: rgba(0, 0, 0, 0.7);
  $background-color_2: rgba(0, 0, 0, 0.07);



  .counter {
    display: flex;
    align-items: center;

   
  }
  .title {
    margin-bottom: 0.25rem;
    color: black;
    font-size: 1rem
  }
  .variant {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    color: $color_3;
  }
  .counter {
    span {
      margin: 0 1rem;
    }
    button {
      font-size: 1.1rem;
      padding: 0;
      background-color: $background-color_2;
      width: 25px;
      height: 25px;
      border-radius: 5px;
    }
  }
  .price-q-counter-container {
    justify-content: space-between;
    align-items: center;
    margin-top: 0.5rem;
  }
  .line-item-parent-container {
    position: relative;
    align-items: flex-start;
    padding: 2rem 1rem;
    border-bottom: var(--primary-border);
    .delete {
      position: absolute;
      top: 0;
      margin-top: 1rem;
      right: 0%;
    }
    p {
      margin-top: 0;
    }
    div {
      flex-grow: 2;
    }

    .img-container {
      height: 100px;
      max-width: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
      border: var(--primary-border);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .price-info {
    .total-price {
      color: black;
      font-weight: 500;
      margin: 0;
      font-size: 1.2rem
    }
  }
</style>
